import UserManagement from "../pages/UserManagement";
import LoginPage from "../pages/LoginPage";
import { createBrowserRouter } from "react-router-dom";
import AddUser from "../pages/AddUser";

import ProtectedRoute from "../components/ProtectedRoute";
import { Navigate } from 'react-router-dom';

const browserRouter = createBrowserRouter([
  {
    path: "/home",
    element: (
      <ProtectedRoute>
        <UserManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
  path: "/users/edit/:id",
  element: (
    <ProtectedRoute>
      <AddUser />
    </ProtectedRoute>
  ),
},
  {
  path: "/users/add",
  element: (
    <ProtectedRoute>
      <AddUser />
    </ProtectedRoute>
  ),
},
]);

export default browserRouter;